/**
 * example message: 
 * {
 	"messageType": "softOrder",
 	"tradePlanId": 1,
 	"tradePlanType": "BASIC_TRADING_SYSTEM",
 	"value": {
 		"timeStamp": "1645480284073",
 		"tacticId": "POSITION_PRICE_TRAIL|BASIC_TRADING_SYSTEM16454802835571",
 		"tactic": "POSITION_PRICE_TRAIL",
 		"symbol": "XYZ",
 		"tacticValue": {"priceToBreak":0.8,"amount":0.2} 	}
 }

 * @param {*} pluginTemplate 
 * @returns object with two feilds:
 * 1) amount (size of trail)
 */
export function positionPriceTrailParser(pluginTemplate) {
    const parsedObject = {
        amount: null
    }
    if(pluginTemplate) {
        parsedObject.amount=pluginTemplate.amount;
    }
    return parsedObject;
}